import { Box, Button, FileQuestionIcon, styled, Typography } from 'opensolar-ui'
import { useTranslate } from 'ra-core'
import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import Notice from 'projectSections/sections/manage3/common/Notice'

interface PropTypes {
  hasFilters?: boolean
}

const StyledSubtext = styled('span')(({ theme }) => ({
  color: theme.palette.grey[500],
  maxWidth: 650,
  lineHeight: '20px',
}))

const EmptyStateWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '40px 24px',
  height: '100%',
  minHeight: 0,
  flex: 1,
})

const EmptyStateHeading = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[900],
  fontWeight: theme.typography?.fontWeightBold ?? 600,
  marginBottom: '32px',
}))

const EmptyStateMessageBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: '8px',
  padding: '24px 24px',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
}))

const EmptyStateMessage = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.grey[700],
  lineHeight: '20px',
  textAlign: 'center',
}))

const StartProjectButton = styled(Button)(({ theme }) => ({
  backgroundColor: `${theme.palette.blue[700]} !important`,
  color: `${theme.palette.common.white} !important`,
  '&:hover': {
    backgroundColor: `${theme.palette.blue[800]} !important`,
  },
}))

const EmptyState: FC<PropTypes> = ({ hasFilters = false }) => {
  const translate = useTranslate()
  const history = useHistory()

  if (hasFilters) {
    return (
      <Notice
        icon={<FileQuestionIcon width={'20px'} height={'20px'} />}
        mainText={translate("We couldn't find any projects that match your filter criteria")}
        subText={
          <StyledSubtext>
            {translate(
              'Try adjusting your filters, checking for any typos, or clearing all filters to see all projects.'
            )}
          </StyledSubtext>
        }
      />
    )
  }

  return (
    <EmptyStateWrapper>
      <EmptyStateHeading variant="h3">{translate('No Projects To Display')}</EmptyStateHeading>
      <EmptyStateMessageBox>
        <EmptyStateMessage>
          {translate("Once you've added a project with a system, it will appear here.")}
        </EmptyStateMessage>
        <StartProjectButton
          variant="contained"
          size="medium"
          disableElevation
          onClick={() => history.push('/')}
        >
          {translate('Start A Project')}
        </StartProjectButton>
      </EmptyStateMessageBox>
    </EmptyStateWrapper>
  )
}

export default EmptyState

